import * as ko from "knockout";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {nsMapping} from "./fn";
import {_} from 'lodash';
import {ObjectTypeId} from "../../../constants";
import expressionHtml from './expression.html?raw';

export let template: string = expressionHtml;

interface IParams {
    expression: KnockoutObservable<string>
    objecttype: KnockoutObservable<ObjectTypeId>
}

enum ViewType {
    Default,
    Transform
}

export class viewModel {
    ViewType = ViewType;
    expression: KnockoutObservable<string>;
    objecttype: KnockoutObservable<ObjectTypeId>;
    componentType: KnockoutObservable<ViewType | null> = ko.observable(null);
    data?: IMutableExpressionTransformMapping;

    private kosub = new KOSubscriptionTracker();

    constructor(params: IParams) {
        this.expression = params.expression;
        this.objecttype = params.objecttype;
        this.componentType(ViewType.Default);
    }

    isViewType(type: ViewType): boolean {
        return type == this.componentType();
    }

    onAddTransformClick() {
        this.addTransform();
    }

    private addTransform(source: string = "", destination: string = "") {
        if (!this.data) {
            return;
        }
        const s = ko.observable(source);
        const d = ko.observable(destination);
        this.data.mappings.push({
            source: s,
            destination: d
        });
        this.kosub.subscribe(s, this.onTransformChange.bind(this));
        this.kosub.subscribe(d, this.onTransformChange.bind(this));
    }

    onRemoveTransformClick(item: IMutableTransformMapping) {
        this.data?.mappings.remove(item);
    }

    isExpressionType(type: ViewType): boolean {
        switch(type) {
            case ViewType.Default:
                return true;
            case ViewType.Transform:
                return this.expression().indexOf("[TRANSFORM;") == 0;
        }

    }

    changeView(type: ViewType) {
        switch(type) {
            case ViewType.Default:
                this.kosub.unsuscribeAll();
                delete this.data;
                break;
            case ViewType.Transform:
                const data: IExpressionTransformMapping = nsMapping.parseExpression(this.expression());
                this.data = {
                    subject: ko.observable(data.subject),
                    mappings: ko.observableArray<IMutableTransformMapping>([])
                };
                _.sortBy(data.mappings, (o: ITransformMapping) => o.source.toLowerCase()).forEach((item: ITransformMapping) => this.addTransform(item.source, item.destination));
                this.kosub.subscribe(this.data.subject, this.onTransformChange.bind(this));
                this.kosub.subscribe(this.data.mappings, this.onTransformChange.bind(this));
                break;
        }
        this.componentType(type);
    }

    private onTransformChange() {
        if (!this.data) {
            return;
        }
        const exp: string[] = [];
        exp.push("TRANSFORM");
        exp.push(this.data.subject());
        _.forEach(this.data.mappings(), (item: IMutableTransformMapping) => {
            const source = item.source();
            const destination = item.destination();
            exp.push(source + "|" + destination)
        });
        this.expression("[" + exp.join(";") + "]");
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }

}
